import { useQuery } from 'react-query'
import { occurrencesService } from '../../../services/occurrencesService'

export const mentionableKey = (processId: number) =>
  ['occurrences', 'mentionable', processId] as const

export function useMentionableEmployees(processId: number | null) {
  return useQuery(
    processId
      ? mentionableKey(processId)
      : ['occurrences', 'mentionable', 'idle'],
    () => occurrencesService.listMentionable(processId as number),
    {
      enabled: !!processId,
      staleTime: 5 * 60 * 1000,
    },
  )
}
